import { useOnStartLayers } from './LayersOnStart/useOnStartLayers';
import { useLoadFiltersOnStart } from './FiltersOnStart/useLoadFiltersOnStart';
import { useFavoritePortOnStart } from './useFavoritePortOnStart';

export const useOnMapStart = () => {
  useLoadFiltersOnStart();
  useOnStartLayers();
  useFavoritePortOnStart();
};
